import { render, staticRenderFns } from "./LoadingCell.vue?vue&type=template&id=85e8b4c0&scoped=true"
import script from "./LoadingCell.vue?vue&type=script&lang=js"
export * from "./LoadingCell.vue?vue&type=script&lang=js"
import style0 from "./LoadingCell.vue?vue&type=style&index=0&id=85e8b4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e8b4c0",
  null
  
)

export default component.exports